// extracted by mini-css-extract-plugin
export var messagecustomer = "product-special-message-module--messagecustomer--YiElY";